import React, { useState } from 'react';

import { createCtx } from 'src/context/ContextUtils';
import { OptionFilterType } from 'src/components/calendar/TypeCustom';
import { getToday } from 'src/common/helper';

type ButtonType = {
  bgColor: string;
  color: string;
};

type StoreType = {
  palette: {
    container: {
      bgColor: string;
      paper: string;
    };
    button: {
      main: ButtonType;
      light: ButtonType;
    };
    link: {
      color: string;
    };
    input: {
      color: string;
      placeholder: string;
      bgColor: string;
      border: string;
    };
    calendar: {
      text: {
        color: string;
        disable: string;
      };
      colorDayofWeek: string;
      bgColor: string;
      selected: string;
    };
  };
  title: string;
};

type StoreContextType = {
  store: StoreType;
  setStore: React.Dispatch<React.SetStateAction<StoreType>>;
  dateSelected: string;
  setDateSelected: React.Dispatch<React.SetStateAction<string>>;
  optionFilter: OptionFilterType[];
  setOptionFilter: React.Dispatch<React.SetStateAction<OptionFilterType[]>>;
  isToDay: boolean;
  setIsToday: React.Dispatch<React.SetStateAction<boolean>>;
  notifications: string[];
  setNotifications: React.Dispatch<React.SetStateAction<string[]>>;
  tabCalendar: 'calendar' | 'schedule' | '';
  setTabCalendar: React.Dispatch<React.SetStateAction<'calendar' | 'schedule' | ''>>;
  optionFilterSelected: number[];
  setOptionFilterSelected: React.Dispatch<React.SetStateAction<number[]>>;
};

type StoreProviderProps = {
  children: React.ReactNode;
};

export const [useStore, StoreContextProvider] = createCtx<StoreContextType>();

export const StoreProvider = (props: StoreProviderProps) => {
  const [store, setStore] = useState<StoreType>({
    palette: {
      container: {
        bgColor: '#FAFAFA',
        paper: '#FFFFFF',
      },
      button: {
        main: {
          color: 'linear-gradient(95.64deg, #00C3FF 0%, #0090F8 100%)',
          bgColor: '#23B7E5',
        },
        light: {
          color: '#23B7E5',
          bgColor: '#FFFFFF',
        },
      },
      link: {
        color: '#23B7E5',
      },
      input: {
        color: 'rgba(0, 0, 0, 0.87)',
        placeholder: '#CCD1D9',
        bgColor: '#FFFFFF',
        border: '#F3F3F3',
      },
      calendar: {
        text: {
          color: '#434154',
          disable: '#CCD1D9',
        },
        colorDayofWeek: '#AAB2BD',
        bgColor: '#F5F8FE',
        selected: '#23B7E5',
      },
    },
    title: 'リゾナスフェイスクリニック東京',
  });

  const [dateSelected, setDateSelected] = useState<string>(getToday('YYYY-MM-DD'));

  const [optionFilter, setOptionFilter] = useState<OptionFilterType[]>([]);

  const [isToDay, setIsToday] = useState<boolean>(false);

  const [tabCalendar, setTabCalendar] = useState<'calendar' | 'schedule' | ''>('');

  const [optionFilterSelected, setOptionFilterSelected] = useState<number[]>([]);

  const [notifications, setNotifications] = useState<string[]>(["1"]);

  return (
    <>
      <StoreContextProvider
        value={{
          store,
          setStore,
          dateSelected,
          setDateSelected,
          optionFilter,
          setOptionFilter,
          isToDay,
          setIsToday,
          notifications,
          setNotifications,
          tabCalendar,
          setTabCalendar,
          optionFilterSelected,
          setOptionFilterSelected
        }}
      >
        {props.children}
      </StoreContextProvider>
    </>
  );
};
